export const GAP_BETWEEN_ITEMS = 16;
export const CARD_ITEM_SETTINGS = {
    sm: {
        width: '242px',
    },
};
export const FOR_OWNERS_MAX_CARD = 3;
export const FOR_OWNERS_COMPONENT_ID = 'for-owners-component-id';
